/* eslint-disable no-console */
import React from 'react';
// @material-ui/core components
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import AuthContext from 'helpers/authContext';
import PromotedAdCreate from 'components/PromotedAd/Create';

const ScreenPromotedAdCreate = () => {
  const { ad, bundle } = useQueryString();
  return (
    <GridContainer justify="center">
      <GridItem xs={12} sm={9} md={8} lg={7}>
        <AuthContext.Consumer>
          {value => <PromotedAdCreate ad={ad} bundle={bundle} me={value} />}
        </AuthContext.Consumer>
      </GridItem>
    </GridContainer>
  );
};

export default ScreenPromotedAdCreate;
